import "./navBar.css";
import { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      {/* Announcement Bar */}
      <div className="py-2 secondary-color text-white text-center text-sm">
        <a href="https://www.facebook.com/nopeetph/">
        Watch our Daily Live on Facebook for discounts
        </a>
       
      </div>

      {/* Main Navbar */}
      <nav className="bg-white px-4 lg:px-12  flex items-center justify-between  mx-auto">
        {/* Logo */}
        <Link to="/homePage" className="flex items-center">
          <img
            src={require("../assets/Mainlogo.png")}
            alt="Main Logo"
            className="mainlogo-img w-24 md:w-32 lg:w-40"
          />
        </Link>

        {/* Desktop Menu */}
        <ul className="hidden lg:flex items-center space-x-6 text-gray-900 font-medium">
          <li>
            <Link to="/discount-page#" className="hover:text-yellow-700">
              Discounted Offers
            </Link>
          </li>
          <li>
          <Link to="/earrings-page#" className="hover:text-yellow-700">
              Earrings
            </Link>
           
          </li>
          <li className="hidden md:inline">
          <Link to="/engagement-page#" className="hover:text-yellow-700">
          Engagement Rings
            </Link>
            
          </li>
          <li className="hidden md:inline">
          <Link to="/eternity-page#" className="hover:text-yellow-700">
          Eternity Rings
            </Link>
           
          </li>
          <li className="hidden md:inline">
          <Link to="/necklace-page#" className="hover:text-yellow-700">
          Necklace
            </Link>
          </li>
          <li className="hidden lg:inline">
          <Link to="/bracelet-page#" className="hover:text-yellow-700">
          Bracelets
            </Link>
        
          </li>
          <li className="hidden lg:inline">
          <Link to="/bangles-page#" className="hover:text-yellow-700">
          Bangles
            </Link>
        
         
          </li>
        </ul>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="lg:hidden p-2 rounded-md focus:outline-none"
        >
          <svg
            className="w-6 h-6 text-gray-900"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white shadow-md p-4 absolute top-16 w-full left-0 right-0">
          <ul className="space-y-4 text-gray-900 font-medium text-center">
            <li>
              <Link to="/discount-page" className="hover:text-yellow-700">
                Discounted Offers
              </Link>
            </li>
            <li>
            <Link to="/earrings-page#" className="hover:text-yellow-700">
          Earrings
            </Link>
            </li>
            <li>
            <Link to="/engagement-page#" className="hover:text-yellow-700">
          Engagement Rings
            </Link>
            </li>
            <li>
            <Link to="/eternity-page#" className="hover:text-yellow-700">
          Eternity Rings
            </Link>
            </li>
            <li>
            <Link to="/necklace-page#" className="hover:text-yellow-700">
            Necklace
            </Link>
            </li>
            <li>
            <Link to="/bracelet-page#" className="hover:text-yellow-700">
            Bracelets
            </Link>
            </li>
            <li>
            <Link to="/bangles-page#" className="hover:text-yellow-700">
            Bangles
            </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
